(function() {
  'use strict';

  var SESSION_KEY = 'age_verified';

  // 年齢確認ページ自体では動作しない
  if (window.location.pathname.includes('/pages/age-gate')) {

    // 「はい」ボタン
    document.getElementById('ageGateYes')
      ?.addEventListener('click', function() {
        sessionStorage.setItem(SESSION_KEY, '1');
        window.location.href = window.AGE_GATE_REDIRECT || '/';
      });

    // 「いいえ」ボタン
    document.getElementById('ageGateNo')
      ?.addEventListener('click', function() {
        var body = document.getElementById('ageGateBody');
        var denied = document.getElementById('ageGateDenied');
        if (body) body.style.display = 'none';
        if (denied) denied.style.display = 'block';
      });

    return;
  }

})();
